/**
 * User-facing captcha strings, centralised per the no-inline-duplicated-literals
 * rule (shared by every auth screen that embeds the captcha).
 */
// The captcha is invisible (execute-on-submit, interaction-only), so the copy
// must not reference a captcha the user can't see.
export enum CaptchaMessage {
  FailedSummary = 'Security Check Failed',
  Failed = "We couldn't verify your browser. Please try again — if it keeps failing, refresh this page.",
}
